/**
 * ServiceOrderModuleGuard - Bloqueia rotas da Ordem de Serviço quando o módulo está desligado
 *
 * A proteção real está nas RPCs (`_os_assert_permission`); este guard só
 * evita exibir telas vazias e redireciona para o início.
 *
 * RELEASE: 2026-10-08 v1.0.0 - Criação inicial (Fase 1 da OS).
 */
import { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import { Skeleton } from '@/components/ui/skeleton';
import { useServiceOrderModule } from '@/hooks/useServiceOrderModule';

export function ServiceOrderModuleGuard({ children }: { children: ReactNode }) {
  const { isEnabled, isLoading } = useServiceOrderModule();
  if (isLoading) return <Skeleton className="m-6 h-40 rounded-lg" />;
  if (!isEnabled) return <Navigate to="/tenant/chat" replace />;
  return <>{children}</>;
}
